module.exports = __webpack_public_path__ + "static/media/xmlIcon.46c6c1e0.svg";